import { FormSectionHandler } from '../entity.handler';
import { ZoneGroupResponse, IdName, ZoneGroupUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    parent?: IdName;
}

export class ZoneGroupDetailsSectionHandler implements FormSectionHandler<ZoneGroupResponse, EditorValues> {

    type = 'form';
    icon = ICONS.zonegroup;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService
    ) {
    }

    private properties = ['name', 'parent'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ZONEGROUP.DETAILS.${key}`, values);
    }

    applyUpdate(entity: ZoneGroupResponse, payload: ZoneGroupUpdateRequest): Promise<ZoneGroupResponse> {
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.updateZoneGroup(entity.id, payload));
    }

    mapEntityToEditor(entity: ZoneGroupResponse): Promise<EditorValues> {
        if (!entity.parent) {
            entity.parent = { id: 'root', name: this.admin.i18n.instant('SHARED.ROOT')};
        }
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: ZoneGroupUpdateRequest, values: EditorValues): Promise<ZoneGroupUpdateRequest> {
        const result = EntityUtils.mergeFields<ZoneGroupUpdateRequest>(this.properties, values, entity);
        if (result.parent && result.parent.id === 'root') {
            result.parent = null;
        }
        return Promise.resolve(result);
    }

    getFields(entity: ZoneGroupResponse): Promise<FormBuilderField[]> {
        return this.grouping.getZoneGroups(this.ownerId).then(zoneGroups => {

            const values = [
                { key: 'root', value: this.admin.i18n.instant('SHARED.ROOT') },
                ...EntityUtils.treeToComboValues(zoneGroups, 1),
            ];

            return [
                ComboField('parent', this.translate('FIELDS.PARENT'), true, values, IdNameComboValueHandlers),
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
